import { combineReducers } from 'redux';

import {
    REQUEST_GET_IBAN,
    SUCCESS_GET_IBAN,
    FAILURE_GET_IBAN,
    REQUEST_CREATE_IBAN,
    SUCCESS_CREATE_IBAN,
    FAILURE_CREATE_IBAN,
    REQUEST_DELETE_IBAN,
    SUCCESS_DELETE_IBAN,
    FAILURE_DELETE_IBAN,
    RESET_FORM_SUBMIT_UPDATE_IBAN,
    SET_TIMEOUT_ID,
    CLEAR_TIMEOUT_ID
} from './constants';

const ibans = (state = [], action) => {
    switch (action.type) {
        case SUCCESS_GET_IBAN:
        case SUCCESS_CREATE_IBAN:
        case SUCCESS_DELETE_IBAN:
            return action.response.payload;
        case REQUEST_GET_IBAN:
        case FAILURE_GET_IBAN:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_GET_IBAN:
            return true;
        case FAILURE_GET_IBAN:
        case SUCCESS_GET_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_GET_IBAN:
            return action.response.message;
        case REQUEST_GET_IBAN:
        case SUCCESS_GET_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return '';
        default:
            return state;
    }
};

const createIbanSuccess = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_CREATE_IBAN:
            return true;
        case REQUEST_CREATE_IBAN:
        case FAILURE_CREATE_IBAN:
        case SUCCESS_DELETE_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return false;
        default:
            return state;
    }
};

const createIbanFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_CREATE_IBAN:
            return true;
        case FAILURE_CREATE_IBAN:
        case SUCCESS_CREATE_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return false;
        default:
            return state;
    }
};

const createIbanError = (state = '', action) => {
    switch (action.type) {
        case FAILURE_CREATE_IBAN:
            return action.response.message;
        case REQUEST_CREATE_IBAN:
        case SUCCESS_CREATE_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return '';
        default:
            return state;
    }
};

const deleteIbanSuccess = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_DELETE_IBAN:
            return true;
        case REQUEST_DELETE_IBAN:
        case FAILURE_DELETE_IBAN:
        case SUCCESS_CREATE_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return false;
        default:
            return state;
    }
};

const deleteIbanFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_DELETE_IBAN:
            return true;
        case FAILURE_DELETE_IBAN:
        case SUCCESS_DELETE_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return false;
        default:
            return state;
    }
};

const deleteIbanError = (state = '', action) => {
    switch (action.type) {
        case FAILURE_DELETE_IBAN:
            return action.response.message;
        case REQUEST_DELETE_IBAN:
        case SUCCESS_DELETE_IBAN:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return '';
        default:
            return state;
    }
};

const resetTimeoutId = (state = -1, action) => {
    switch (action.type) {
        case SET_TIMEOUT_ID:
            return action.timeoutId;
        case CLEAR_TIMEOUT_ID:
        case RESET_FORM_SUBMIT_UPDATE_IBAN:
            return -1;
        default:
            return state;
    }
};

export default combineReducers({
    ibans,
    fetching,
    error,
    createIbanSuccess,
    createIbanFetching,
    createIbanError,
    deleteIbanSuccess,
    deleteIbanFetching,
    deleteIbanError,
    resetTimeoutId
});



// WEBPACK FOOTER //
// ./src/services/account/iban/reducer.js